import { Component } from "./Component";
// import {Group} from "./Group";

const d3 = require("d3");

export class Divider extends Component {
    parentEltD3 = null;

    // allComponentsOfGroup = []

    constructor(data) {
        super(data, null);
    }

    static async create(data, parentEltD3) {
        let component = new Divider(data);
        component.parentEltD3 = parentEltD3;
        component.type = Component.TYPE_DIVIDER;
        return await component._init(data);
    }

    _init(data) {
        return this._loadSvg(data.src).then(elt => {
            if (elt) {
                this.elt = elt;
                this.parentEltD3.node().appendChild(elt);

                this.eltD3 = d3
                    .select(elt)
                    .data([data])
                    .attr("id", data.UUID)
                    .attr("height", data.height)
                    .attr("width", data.width);
                // .attr('x', data.x)
                // .attr('y', data.y)

                this.positionOrigin.x = data.x;
                this.positionOrigin.y = data.y;
                this.toPosition(this.positionOrigin);
            }

            return this;
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/plano/components/Divider.js